export enum OrganisationType {
    School = "School",
    NonProfit = "Non Profit",
    PublicSector = "Public Sector",
    Commercial = "Commercial",
    Other = "Other",
}
